const Benefit = () => import("@/views/ADMIN/Benefit.vue");
const BenefitDashboard = () => import("@/components/Benefit/Dashboard.vue");
const BenefitRequest = () => import("@/components/Benefit/BenefitRequest.vue");
const BenefitSettings = () => import("@/components/Benefit/Settings.vue");
const BenefitAddEdit = () => import("@/components/Benefit/AddEdit.vue");

export const benefitList = {
  path: "/beneficios",
  name: "Beneficios",
  meta: { requiresAuth: true },
  component: Benefit,
  redirect: { name: "benefit-Dashboard" },
  children: [
    {
      path: "Dashboard",
      meta: { requiresAuth: true},
      name: "benefit-Dashboard",
      component: BenefitDashboard,
    },
    {
      path: "solicitud/:id",
      meta: { requiresAuth: true},
      name: "solici-request",
      component: BenefitRequest,
    },
    {
      path: "configuracion",
      meta: { requiresAuth: true},
      name: "benefit-settings",
      component: BenefitSettings,
    },
    {
      path: "beneficio",
      meta: { requiresAuth: true},
      name: "benefit-add",
      component: BenefitAddEdit,
    },
    {
      path: "beneficio/:id",
      meta: { requiresAuth: true},
      name: "benefit-edit",
      component: BenefitAddEdit,
    }
  ],
};
